import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationDeviceCreateRequest,
    ConfigurationDevicePatchInBatchRequest,
    ConfigurationDeviceResponse
} from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationDeviceService {
    async create(laboratoryId: number, request: ConfigurationDeviceCreateRequest): Promise<ConfigurationDeviceResponse> {
        const response = await axios.post<ConfigurationDeviceResponse>(`/configuration/laboratories/${laboratoryId}/devices`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationDeviceResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationDeviceResponse>>(`/configuration/laboratories/${laboratoryId}/devices`, { ...filterModel }, { params })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationDevicePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/devices`, request)
        return response.data
    }

    async get(laboratoryId: number, deviceId: number): Promise<ConfigurationDeviceResponse> {
        const response = await axios.get<ConfigurationDeviceResponse>(`/configuration/laboratories/${laboratoryId}/devices/${deviceId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/devices/batch`, { data: request })
        return response.data
    }
}

export const configurationDeviceService = new ConfigurationDeviceService()
